export default __webpack_public_path__ + "static/media/tutorial-set-policies-1.40fa84bf.png";